import React from 'react';
// import { useHistory } from 'react-router-dom';
// import { ppiInProgressRoute } from '../routes';
import Table from '../components/Table/Table';
import { EnrichmentData, States } from '../features/PpiContainer/constants';
import usePpis from '../features/PpiContainer/hooks/usePpis';
import useViewVisited from '../features/app/hooks/useViewVisted';
import ppiColumns from '../features/PpiContainer/ui/columns';
import View from './views';
import PaperContainer from '../components/common/PaperContainer';
import ProgressFullscreen from '../components/common/ProgressFullscreen';

const PpiDraftListView = () => {
  // const history = useHistory();
  const [isFetching, ppis] = usePpis(States.DRAFT);
  const { isViewVisited } = useViewVisited('PPI_DRAFT_LIST', isFetching);
  const isFetched = isViewVisited ? true : !isFetching;
  const Columns = ppiColumns(EnrichmentData.IN_PROGRESS);

  // const editPpi = ppi => {
  //   history.push(ppiInProgressRoute(ppi.id));
  // };

  if (isFetching) {
    return <ProgressFullscreen open />;
  }

  View.PpiListDraft.visit();

  return (
    <PaperContainer>
      <Table
        title="ppi.draftListTableTitle"
        data={ppis}
        columns={[
          Columns.IFoodID,
          Columns.PresentationName,
          Columns.ModifyDate,
          Columns.ModifiedBy,
          Columns.Updates
        ]}
        getObjectId={object => object.id}
        defaultSorting={[{ columnName: 'presentationName', direction: 'asc' }]}
        selectable
        // onRowClick={editPpi}
      />
    </PaperContainer>
  );
};

export default PpiDraftListView;
